import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import en from './en.json';
import da from './da.json';

const translations = { en, da };

const LanguageContext = createContext();

export function LanguageProvider({ children, initialLanguage = 'en' }) {
  const [language, setLanguageState] = useState(initialLanguage);

  // Sync language when initialLanguage changes (e.g., after login)
  useEffect(() => {
    if (translations[initialLanguage]) {
      setLanguageState(initialLanguage);
    }
  }, [initialLanguage]);

  const setLanguage = useCallback((lang) => {
    if (translations[lang]) {
      setLanguageState(lang);
    }
  }, []);

  const t = useCallback((key) => {
    // key format: "section.key" e.g., "common.save"
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value || key;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
